import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgErrorAlt(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <circle cx={16} cy={16} r={16} fill="#CC0029" />
      <path
        fill="white"
        d="M15.9999 17.8856L21.0571 22.9427L22.9427 21.0571L17.8856 15.9999L22.9427 10.9427L21.0571 9.05713L15.9999 14.1143L10.9427 9.05713L9.05713 10.9427L14.1143 15.9999L9.05713 21.0571L10.9427 22.9427L15.9999 17.8856Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgErrorAlt);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
